/*
 * Background video in the image banner.
 *
 * The markup carries `autoplay`, so the video plays on its own and this file
 * only handles the two cases the attribute cannot:
 *
 *   1. Reduced motion. A viewer who has asked for less movement should get the
 *      poster frame, not a looping clip. `autoplay` cannot be revoked in CSS,
 *      so the video is paused here and its source left unloaded.
 *
 *   2. Autoplay being refused. Browsers block autoplay in some conditions even
 *      when the video is muted (low power mode, data saver, per-site setting).
 *      The play() promise rejects there, and the poster is what remains on
 *      screen — which is the correct fallback, so the rejection is swallowed
 *      rather than logged as an error.
 *
 * Nothing here is required for the banner to render: with JS off the video
 * autoplays as the attribute says, and the poster covers the gap until it does.
 */
(function () {
  'use strict';

  var REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

  function setup(video) {
    if (video.dataset.mkBannerVideoReady === 'true') return;
    video.dataset.mkBannerVideoReady = 'true';

    var prefersReduced = window.matchMedia && window.matchMedia(REDUCED_MOTION).matches;

    if (prefersReduced) {
      // removeAttribute before pause(): leaving autoplay on means the browser
      // may start it again after a source or visibility change.
      video.removeAttribute('autoplay');
      video.pause();
      return;
    }

    // iOS only honours muted autoplay when the element is genuinely muted at
    // the property level. The attribute alone has historically been ignored by
    // WebKit when the markup is injected rather than parsed from the document
    // — which is exactly what happens on a theme-editor section reload — and
    // the video then silently refuses to start. Setting it here is cheap and
    // makes the guarantee explicit on every device.
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        /* Autoplay refused — the poster stays, which is the intended fallback. */
      });
    }
  }

  function init(root) {
    (root || document).querySelectorAll('.banner__video').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // The theme editor re-renders a section in place, so a video added or
  // changed there is wired up without a reload.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
